import { tss } from '@/shared/styles/tss'

export const useStyles = tss.withName('TapRingEffect').create(() => ({
  container: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    pointerEvents: 'auto',
    overflow: 'hidden',
    zIndex: 9999,
  },
  ring: {
    position: 'absolute',
    width: '40px',
    height: '40px',
    borderRadius: '50%',
    backgroundColor: 'rgba(255, 255, 255, 0.5)',
    transform: 'scale(0)',
    animation: 'tapRingAnimation 1s linear forwards',
    pointerEvents: 'none',
    marginLeft: '-20px',
    marginTop: '-20px',
    '@keyframes tapRingAnimation': {
      '0%': {
        transform: 'scale(0)',
        opacity: 1,
      },
      '100%': {
        transform: 'scale(4)',
        opacity: 0,
      },
    },
  },
}))
